import { render, staticRenderFns } from "./MojeGrupe.vue?vue&type=template&id=5e6b8034&scoped=true&"
import script from "./MojeGrupe.vue?vue&type=script&lang=js&"
export * from "./MojeGrupe.vue?vue&type=script&lang=js&"
import style0 from "./MojeGrupe.vue?vue&type=style&index=0&id=5e6b8034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6b8034",
  null
  
)

export default component.exports